























import { Component, Vue, Prop, Provide } from "vue-property-decorator"
import QuestionConditionFormFields from './QuestionConditionFormFields.vue'
@Component({
  components: {
    QuestionConditionFormFields
  }
})
export default class QuestionConditionList extends Vue {
  @Prop() readonly conditions!: Model[]
  @Prop({ default: false, type: Boolean }) readonly noRpi!: boolean
  @Prop() readonly questions!: BridgeModel[]
  @Prop() readonly sourceTypes!: Record<string, string>[]
  @Prop({ default: 'Conditions' }) readonly title!: string
  @Provide() hasNoRpi = this.noRpi

  get conditionTableHeaders() {
    const defaultHeader = [
      {
        text: "ID",
        align: "left",
        sortable: false,
      },
      {
        text: "Source",
        align: "left",
        width: "18%",
        sortable: false,
      },
      {
        text: "Source-related Selection",
        align: "left",
        sortable: false,
      },
      {
        text: "Attribute",
        align: "left",
        sortable: false,
      },
      {
        text: "Operation",
        align: "left",
        sortable: false,
      },
      {
        text: "Value",
        align: "left",
        sortable: false,
      },
      {
        text: "Action",
        sortable: false,
      },
    ]
    return defaultHeader
  }

  addCondition() {
    this.conditions.push({
      source_type: "question",
      source_key: "",
      matching_operator: "",
      matching_value: "",
    })
  }

  handleDeleteCondition(index) {
    this.conditions.splice(index, 1)
  }
}
